import { useRef, useEffect, useCallback } from 'react';

import { AnyToastItem } from 'modules/ToastList/types';

const useToastPresence = (toastState: AnyToastItem[]) => {
  const toastStateRef = useRef<AnyToastItem[]>(toastState);

  useEffect(() => {
    toastStateRef.current = toastState;
  }, [toastState]);

  const isToastPresent = useCallback(
    (toastId: string) => toastStateRef.current.some((toast) => toast.id === toastId),
    []
  );

  return isToastPresent;
};

export default useToastPresence;
